// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"8f99ea8f","305":"1425c93d","311":"41109ae9","379":"0cafaa64","482":"7ee359b1","545":"a63868ad","787":"813fa7cf","921":"4b2899a6","975":"790e372a","997":"20b2d587"}[chunkId] + ".chunk.js";
};